import { Typography } from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Colors } from '../utils/Theme';

interface Props {
  href: string;
  label: string;
  active?: boolean;
}

export const LinkItem: FC<Props> = ({ href, label, active }) => {
  return (
    <Link
      to={href}
      style={{
        textDecorationLine: active ? 'underline' : 'none',
        textDecorationColor: Colors.PRIMARY_COLOR,
      }}
    >
      <Typography fontSize={18} fontWeight="500" variant="body1" color={active ? 'primary' : Colors.BLACK_BLUE}>
        {label}
      </Typography>
    </Link>
  );
};
